import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-motivo-cambio-atq',
  templateUrl: './motivo-cambio-atq.component.html',
  styleUrls: ['./motivo-cambio-atq.component.scss', '../../../estilosModales.scss']
})
export class MotivoCambioATQComponent implements OnInit {

  motivo: String = null;
  aceptado = false;
  constructor(public dialogRef: MatDialogRef<MotivoCambioATQComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  cerrarModal(opc) {
    let res = {
      respuesta: opc,
      motivo: this.motivo
    }
    this.dialogRef.close(res);
  }
}
